<template>
    <div class="signature-pad-container">
        <canvas :id="`${_uid}-signature-pad`" class="signature-pad"></canvas>
        <div class="actions">
            <button @click="signaturePad.clear()" class="eraser btn btn-default" :disabled="disableButtons">
                <i class="fa fa-eraser"></i>
            </button>
        </div>
    </div>
</template>
<script>

    export default {

        props: {
            value: {},
        },

        data() {
            return {
                canvas: null,
                signaturePad: null,
            }
        },

        mounted() {
            this.canvas = document.getElementById(`${this._uid}-signature-pad`);
            this.signaturePad = new SignaturePad(this.canvas);
            if(this.value) {
                this.signaturePad.fromDataURL(this.value);
            }
            window.addEventListener("resize", this.resizeCanvas);
            this.resizeCanvas();
        },

        methods: {

            save() {
                var value = this.signaturePad._data.length ? this.signaturePad.toDataURL() : '';
                this.$emit('input', value)
            },

            resizeCanvas() {
                var ratio = Math.max(window.devicePixelRatio || 1, 1);
                this.canvas.width = this.canvas.offsetWidth * ratio;
                this.canvas.height = this.canvas.offsetHeight * ratio;
                this.canvas.getContext("2d").scale(ratio, ratio);
            },

        },

        watch:{
            'signaturePad._data':{
                deep: true,
                handler(){
                    this.save();
                }
            }
        },

        computed: {
            disableButtons() {
                if (this.signaturePad) {
                    return this.signaturePad.isEmpty() || this.submitted;
                }
                return false;
            },
        }
    }
</script>